import React, { useEffect, useState } from 'react'
import CInput from '../components/CInput';
import { Dialog } from 'primereact/dialog';
import { Button } from '@mui/material'
import { CCol, CForm, CRow } from '@coreui/react';
import { useIngredient } from '../contexts/IngredientContext';

const AddIngredientStock = ({ editIngredientId, setEditIngredientId, setAddStockVisible, fetchIngredients, addStockVisible }) => {
    const { manageIngredientStock } = useIngredient()

    const [validated, setValidated] = useState(false);
    const [ingredientDetails, setIngredientDetails] = useState({
        inventory_id: '',
        quantity: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        setValidated(true);

        if (form.checkValidity() === false) {
            e.stopPropagation();

            const firstInvalidInput = form.querySelector(':invalid');
            if (firstInvalidInput) {
                firstInvalidInput.focus();
                firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        } else {
            try {
                const ingredient = await manageIngredientStock(editIngredientId, { ...ingredientDetails, inventory_id: editIngredientId })
                if (!ingredient.error) {
                    handleClose();
                    fetchIngredients()
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    const handleClose = () => {
        setAddStockVisible(false);
        setEditIngredientId(null);
        setIngredientDetails({
            inventory_id: '',
            quantity: '',
        });
    };

    return (
        <Dialog draggable={false} header="Add/Remove Stock" visible={addStockVisible} style={{ width: "25vw" }} onHide={handleClose}>
            <CForm onSubmit={handleSubmit} noValidate validated={validated}>
                <div className='fields-container'>
                    <CRow className="mb-3 mt-3">
                        <CInput
                            label="Quantity"
                            type="number"
                            className='d-flex'
                            labelClassName='w-50'
                            value={ingredientDetails.quantity}
                            onChange={(value) => setIngredientDetails({ ...ingredientDetails, quantity: value })}
                            required={true}
                            errorMessage='Quantity is required.'
                        />
                    </CRow>
                </div>
                <div className="d-flex p-jc-end justify-content-end button-container">
                    <div className='d-flex'>
                        <Button onClick={() => handleClose()} fullWidth variant="contained" color="inherit" >
                            Cancel
                        </Button>
                        <Button fullWidth variant="contained" color='primary' type="submit" className='ms-3'>
                            Submit
                        </Button>
                    </div>
                </div>
            </CForm>
        </Dialog >
    )
}

export default AddIngredientStock
